import React from "react";
import {YesNoRadio} from "../../kompetenceEvaluering/yesNoRadio";
import {SvarInputTypeProps} from "./svarInputTypeCompareMap";
import {BesvaretAf} from "../readSvar/besvaretAf";

export function BooleanInputSvar({
                                     spoergsmaal,
                                     svarNummerIndex,
                                     kompetenceSvarList,
                                     indsendt,
                                     booleanCallback,
                                     readOnly
                                 }: SvarInputTypeProps) {
    const stempel = kompetenceSvarList.find(x => x.svarIndex === svarNummerIndex)?.stempel;
    return (
        <div className={"d-flex align-items-center"}>
            <YesNoRadio
                id={spoergsmaal.id + svarNummerIndex}
                yesNo={kompetenceSvarList.find(x => x.svarIndex === svarNummerIndex)?.booleanSvar}
                addBooleanSvar={x => booleanCallback(x, svarNummerIndex)}
                disabled={indsendt || readOnly}/>
            {stempel &&
                <BesvaretAf includeMargin
                    stempel={stempel}/>
            }
        </div>
    )
}
